import {AuthGuard} from '../../shared/guards/AuthGuard';
import ListPermissionsPresentation from './components/ListPermissionsPresentation';
import {Sidebar} from '../../shared/components';

export const ListPermissionsPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <ListPermissionsPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};